export default __webpack_public_path__ + "static/media/V375_CoC.d5d225c1.pdf";